import { render, staticRenderFns } from "./member_home.vue?vue&type=template&id=01198af1&scoped=true"
import script from "./member_home.vue?vue&type=script&lang=js"
export * from "./member_home.vue?vue&type=script&lang=js"
import style0 from "./member_home.vue?vue&type=style&index=0&id=01198af1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01198af1",
  null
  
)

export default component.exports